
import { Component, Prop, Vue } from 'vue-property-decorator';

import { namespace } from "vuex-class";   
import "@/store/modules/application";
const applicationState = namespace("Application");

import UnderlineForm from "@/components/utils/PopulateForms/components/UnderlineForm.vue";
import CheckBox from "@/components/utils/PopulateForms/components/CheckBox.vue";
import { nameInfoType } from "@/types/Application/CommonInformation";
import { yourInformationInfoDataInfoType } from '@/types/Application/CommonInformation/Pdf';
import { getLocationInfo, getYourInformationResults } from '@/components/utils/PopulateForms/PopulateCommonInformation';
import { aboutAffiantGaDataInfoType, backgroundCivilCourtProceedingsDataInfoType, backgroundCriminalHistoryDataInfoType, backgroundFamilyViolenceDataInfoType, caringForChildGaChildInfoDataInfoType, caringForChildGaDataInfoType, chargesDataInfoType, childGaInfoType, exhibitsDataInfoType, guardianshipAffidavitDataInfoType } from '@/types/Application/GuardianshipAffidavit';

@Component({
    components:{
        UnderlineForm,
        CheckBox       
    }
})

export default class Form5Layout extends Vue {

    @Prop({required:true})
    result!: any;    
    
    @applicationState.State
    public applicantName!: nameInfoType;    

    dataReady = false; 
    existingFileNumber = '';  
   
    yourInfo = {} as yourInformationInfoDataInfoType; 
    address = '';

    childrenInfo = [];
    careDetails = '';
    otherChildrenExist = false;
    otherChildrenInfo = [];

    familyViolenceExists = false;
    familyViolenceDesc = '';

    courtProceedingsExist = false;
    civilProceedingInfo = [];
    exhibitList = [];
    orderList = [];
    porsRecord = {} as exhibitsDataInfoType;
    mcfdRecord = {} as exhibitsDataInfoType;
    crcRecord = {} as exhibitsDataInfoType;
    policeDept = '';

    pastConviction = false;
    convictionDetails = '';
    currentlyConvicted = false; 
    currentCharges = [];

    childFields = [
        {key:"fullName",               label:"Child's full name",                                           tdClass:"border-dark text-center align-middle", thClass:"border-dark text-center align-middle", thStyle:"font-size:8pt; width:30%;"},
        {key:"dob",                    label:"Child's date of birth",                                       tdClass:"border-dark text-center align-middle", thClass:"border-dark text-center align-middle", thStyle:"font-size:8pt; width:15%;"},
        {key:"currentGuardiansToChild",label:"Name(s) of child's current guardian(s)",                      tdClass:"border-dark text-center align-middle", thClass:"border-dark text-center align-middle", thStyle:"font-size:8pt; width:15%;"},        
        {key:"parentsNotGuardians",    label:"Name(s) of child's parent(s) who are not current guardian(s)",tdClass:"border-dark text-center align-middle", thClass:"border-dark text-center align-middle", thStyle:"font-size:8pt; width:21%;"}
    ];

    childRelationshipFields = [
        {key:"fullName",               label:"Child's full name",                 tdClass:"border-dark text-center align-middle", thClass:"border-dark text-center align-middle", thStyle:"font-size:8pt; width:30%;"},
        {key:"relationWithchild",      label:"Nature of relationship to child",   tdClass:"border-dark text-center align-middle", thClass:"border-dark text-center align-middle", thStyle:"font-size:8pt; width:15%;"},
        {key:"lengthOfRelationship",   label:"Length of relationship",            tdClass:"border-dark text-center align-middle", thClass:"border-dark text-center align-middle", thStyle:"font-size:8pt; width:15%;"}
    ];  

    childLivingArrangementFields = [
        {key:"fullName",               label:"Child's full name",                 tdClass:"border-dark text-center align-middle", thClass:"border-dark text-center align-middle", thStyle:"font-size:8pt; width:30%;"},
        {key:"currentLiving",          label:"Current living arrangements",       tdClass:"border-dark text-center align-middle", thClass:"border-dark text-center align-middle", thStyle:"font-size:8pt; width:15%;"}
    ]; 

    otherChildrenFields = [
        {key:"fullName",               label:"Child's full name",                 tdClass:"border-dark text-center align-middle", thClass:"border-dark text-center align-middle", thStyle:"font-size:8pt; width:30%;"},
        {key:"dob",                    label:"Child's date of birth",             tdClass:"border-dark text-center align-middle", thClass:"border-dark text-center align-middle", thStyle:"font-size:8pt; width:15%;"},
        {key:"relation",               label:"Nature of relationship to child",   tdClass:"border-dark text-center align-middle", thClass:"border-dark text-center align-middle", thStyle:"font-size:8pt; width:15%;"}
    ];

    proceedingFields = [
        {key:"itemNo",                 label:"Item #",                                                                      tdClass:"border-dark text-center align-middle", thClass:"border-dark text-center align-middle", thStyle:"font-size:8pt; width:30%;"},
        {key:"partyNames",             label:"Names of the parties to the proceeding",                                      tdClass:"border-dark text-center align-middle", thClass:"border-dark text-center align-middle", thStyle:"font-size:8pt; width:15%;"},
        {key:"courtLocation",          label:"Name and location of court in which the proceeding was conducted",            tdClass:"border-dark text-center align-middle", thClass:"border-dark text-center align-middle", thStyle:"font-size:8pt; width:15%;"},        
        {key:"courtOrderDates",        label:"Date of any orders concerning children under my care made in the proceeding", tdClass:"border-dark text-center align-middle", thClass:"border-dark text-center align-middle", thStyle:"font-size:8pt; width:21%;"}
    ];

    chargeFields = [
        {key:"chargeNature",             label:"Nature of alleged offence",                                       tdClass:"border-dark text-center align-middle", thClass:"border-dark text-center align-middle", thStyle:"font-size:8pt; width:15%;"},
        {key:"chargeDate",               label:"Date of alleged offence",                                         tdClass:"border-dark text-center align-middle", thClass:"border-dark text-center align-middle", thStyle:"font-size:8pt; width:15%;"},        
        {key:"chargeCourtLocation",      label:"Name and location of court in which proceedings are outstanding", tdClass:"border-dark text-center align-middle", thClass:"border-dark text-center align-middle", thStyle:"font-size:8pt; width:21%;"}
    ];
   
    mounted(){
        this.dataReady = false;
        this.extractInfo();       
        this.dataReady = true;        
    }
   
    public extractInfo(){
        this.getGaAffiantInfo();  
        this.getExhibitInfo();        
        this.childrenInfo = this.getChildrenDetails();
        this.getCareDetails();
        this.getFamilyViolenceInfo();
        this.getChargeDetails();
        this.existingFileNumber = getLocationInfo(this.result.otherFormsFilingLocationSurvey);        
    } 

    public getGaAffiantInfo(){ 

        this.yourInfo = {} as yourInformationInfoDataInfoType; 
        this.address = '';
        
        if(this.result?.aboutAffiantGaSurvey){

            let aboutAffiant = {} as aboutAffiantGaDataInfoType;
            aboutAffiant = this.result.aboutAffiantGaSurvey;

            this.yourInfo = getYourInformationResults(aboutAffiant);    
            this.yourInfo.dob = Vue.filter("beautify-date")(aboutAffiant.Dob);       
            const addressInfo = aboutAffiant.ApplicantAddress;

            const addressText = addressInfo.street + ', ' 
                                + addressInfo.city + ', ' 
                                + addressInfo.state + ', ' 
                                + addressInfo.country + ', ' 
                                + addressInfo.postcode;

            this.address = aboutAffiant.inCareOf?.length>0?('Care of '+ addressText ):addressText;
        }
            
    }

    public getFamilyViolenceInfo(){ 

        this.familyViolenceExists = false;
        this.familyViolenceDesc = '';

        if(this.result?.backgroundFamilyViolenceSurvey){

            let familyViolenceData = {} as backgroundFamilyViolenceDataInfoType;
            familyViolenceData = this.result.backgroundFamilyViolenceSurvey;

            this.familyViolenceExists = familyViolenceData.familyViolenceExists == 'y'; 
            
            if(this.familyViolenceExists){
                this.familyViolenceDesc = familyViolenceData.familyViolenceDesc;
            }
        }
    
    }

    public getChildrenDetails(){

        const childrenInfo = [];
        
        const childData: childGaInfoType[] =  this.result.childrenDetailsGaSurvey;

        for (const child of childData){            
            const childInfo = {fullName: '', dob:'', currentGuardiansToChild: '', parentsNotGuardians: '', relationWithchild: '', lengthOfRelationship: '', currentLiving:''};
            childInfo.fullName = Vue.filter('getFullName')(child.name);
            childInfo.dob = Vue.filter('beautify-date')(child.dob);
            childInfo.currentGuardiansToChild = child.currentGuardiansToChild.map(function (guardian) { return guardian.name; }).join(', ');
            if (child.parentsNotGuardiansExist == 'y'){
                for (const parent of child.parentsNotGuardians)
                childInfo.parentsNotGuardians = child.parentsNotGuardians.map(function (parent) { return parent.name; }).join(', ');
            }
            childInfo.relationWithchild = child.relationWithchild;

            if (child.lengthOfRelationship.selected == 'sinceBirth'){
                childInfo.lengthOfRelationship = "Since Birth";
            } else {
                childInfo.lengthOfRelationship = "Since "+ child.lengthOfRelationship?.relationStartDate?Vue.filter('beautify-date')(child.lengthOfRelationship.relationStartDate):'';
            }

            childInfo.currentLiving = child.currentLiving;
            childrenInfo.push(childInfo)
        }        

        return childrenInfo;
    }

    public getCareDetails(){

        this.careDetails = '';
        this.otherChildrenExist = false;
        this.otherChildrenInfo = [];

        const careData: caringForChildGaDataInfoType = this.result.caringForChildGaSurvey;

        if (careData){

            this.careDetails = careData.caringForChildGa?.careDetails?careData.caringForChildGa.careDetails:'';
            this.otherChildrenExist = careData.caringForChildGa?.parentOtherChild == 'y';        

            if (this.otherChildrenExist){
                const childData: caringForChildGaChildInfoDataInfoType[] = careData.childInfo;
                for (const child of childData){            
                    const childInfo = {fullName: '', dob:'', relation: ''};
                    childInfo.fullName = Vue.filter('getFullName')(child.name);
                    childInfo.dob = Vue.filter('beautify-date')(child.dob);            
                    childInfo.relation = child.relation;           
                    this.otherChildrenInfo.push(childInfo);
                } 
                
            } else {
                this.otherChildrenInfo = [{fullName: '', dob:'', relation: ''}];
            }
        } 
    }

    public getExhibitInfo(){  

        this.courtProceedingsExist = false;
        this.civilProceedingInfo = [{itemNo: '', partyNames: '', courtLocation:'', courtOrderDates: []}];
        this.exhibitList = this.result.gaExhibitList;
        this.orderList = [];

        this.porsRecord = {} as exhibitsDataInfoType;
        this.mcfdRecord = {} as exhibitsDataInfoType;
        this.crcRecord = {} as exhibitsDataInfoType;
        this.policeDept = '';

        const proceedingData: backgroundCivilCourtProceedingsDataInfoType = this.result.backgroundCivilCourtProceedingsSurvey;

        if (proceedingData && this.result.gaExhibitList){

            this.courtProceedingsExist = proceedingData.courtProceedingsExist == 'y';
            if(this.courtProceedingsExist){
                this.orderList = this.exhibitList.filter(exhibit => exhibit.itemNo != 0); 
                const civilProceedingsData = this.orderList;
                this.civilProceedingInfo = [];  
                
                let maxItemNo = '';
                
                for (const proceeding of civilProceedingsData){

                    const proceedingInfo = {itemNo: '', partyNames: '', courtLocation:'', courtOrderDates: []};
                    const index = this.civilProceedingInfo.findIndex(proc=>{return(proc.itemNo == proceeding.itemNo)})
                    if(index >= 0 ){                
                        this.civilProceedingInfo[index].courtOrderDates.push(Vue.filter('beautify-date')(proceeding.fileDate)); 
                    } else {
                        proceedingInfo.itemNo = proceeding.itemNo;
                        proceedingInfo.partyNames = proceeding.partyNames;
                        proceedingInfo.courtLocation = proceeding.courtLocation;
                        proceedingInfo.courtOrderDates.push(Vue.filter('beautify-date')(proceeding.fileDate));
                        this.civilProceedingInfo.push(proceedingInfo);
                    }  
                    
                    maxItemNo = proceeding.itemNo;
                }
                
                let noOrderBaseIndex = Number(maxItemNo) + 1;

                for (const proceeding of proceedingData.courtProceedings){

                    if(proceeding.courtOrdersExist == 'n'){
                        const proceedingInfo = {itemNo: '', partyNames: '', courtLocation:'', courtOrderDates: []};                        
                        proceedingInfo.itemNo = String(noOrderBaseIndex);
                        proceedingInfo.partyNames = proceeding.partyNames;
                        proceedingInfo.courtLocation = proceeding.courtLocation;
                        proceedingInfo.courtOrderDates = [];
                        this.civilProceedingInfo.push(proceedingInfo); 
                        noOrderBaseIndex++;
                    }
                                 
                } 


            }
        }

        if(this.result?.guardianshipAffidavitSurvey){

            const ga: guardianshipAffidavitDataInfoType = this.result.guardianshipAffidavitSurvey

            if (ga.haveBrcResults == 'y'){
                const mcfdRecordData = this.exhibitList.filter(exhibit => exhibit.fileName == "Ministry of Children and Family Development Record Check dated ")[0];                
                this.mcfdRecord.exhibitName = mcfdRecordData.exhibitName;
                this.mcfdRecord.fileDate = Vue.filter('beautify-date')(mcfdRecordData.fileDate);

                const crcRecordData = this.exhibitList.filter(exhibit => exhibit.fileName == "Criminal Record Check dated ")[0];
                this.crcRecord.exhibitName = crcRecordData.exhibitName;
                this.crcRecord.fileDate = Vue.filter('beautify-date')(crcRecordData.fileDate);

                const porsRecordData = this.exhibitList.filter(exhibit => exhibit.fileName == "Protection Order Record Check from the Protection Order Registry dated ")[0];
                this.porsRecord.exhibitName = porsRecordData.exhibitName;
                this.porsRecord.fileDate = Vue.filter('beautify-date')(porsRecordData.fileDate)
                this.policeDept = ga.policeDept?ga.policeDept:'';
            }
        }    
    }  

    public getChargeDetails(){

        this.convictionDetails = '';
        this.pastConviction = false;
        this.currentlyConvicted = false;
        this.currentCharges = [];

        const criminalData: backgroundCriminalHistoryDataInfoType = this.result.backgroundCriminalHistorySurvey;

        if (criminalData){

            this.pastConviction = criminalData.pastConviction == 'y';
            if (this.pastConviction){
                this.convictionDetails = criminalData.convictionDetails?criminalData.convictionDetails:'';
            }
            
            this.currentlyConvicted = criminalData.currentlyConvicted == 'y';       

            if (this.currentlyConvicted){
                const chargeData: chargesDataInfoType[] = criminalData.currentCharges;
                for (const charge of chargeData){            
                    const chargeInfo = {chargeNature: '', chargeDate:'', chargeCourtLocation: ''};
                    chargeInfo.chargeNature = charge.chargeNature;
                    chargeInfo.chargeDate = Vue.filter('beautify-date')(charge.chargeDate);            
                    chargeInfo.chargeCourtLocation = charge.chargeCourtLocation;           
                    this.currentCharges.push(chargeInfo);
                } 
                
            } else {
                this.currentCharges = [{chargeNature: '', chargeDate:'', chargeCourtLocation: ''}];
            }
        } 
    }
 
}
